import { Base64Writer } from "./Base64Writer.js"
import { HtmlRasterizer } from "./HtmlRasterizer.js"

export class BluetoothPrinter {

	renderRawBtUrl = (css, innerHtml, canvasWidth, canvasHeight) => {
		const html = `<html style="margin: 0; padding: 0;">
				<head>
					<style>
						${css}
					</style>
				</head>
				<body style="margin: 0; padding: 0;">
					<dic class="receipt">${innerHtml}</div>
				</body>
			</html>`
		return this.renderRawBtUrlFromHTML(html, canvasWidth, canvasHeight)
	}

	renderRawBtUrlFromHTML = (html, canvasWidth, canvasHeight) => {
		return new Promise((resolve, reject) => {
			HtmlRasterizer.renderToCanvas(html, canvasWidth, canvasHeight)
				.then(canvas => {
					const ctx = canvas.getContext("2d")
					const imageData = ctx.getImageData(0, 0, canvasWidth, canvasHeight)
					// Remove canvas after getting data
					canvas.remove()
					// console.debug(imageData)
					const data = imageData.data
					if (imageData.width % 8) {
						alert('Image width can´t be divided by 8: ' + imageData.width)
						reject('Image width can´t be divided by 8: ' + imageData.width)
					}
					const imageByteLines = []
					for (let l = 0; l < imageData.height; l++) {
						let imageByteLine = []
						imageByteLines.push(imageByteLine)
						for (let eightPx = 0; eightPx < imageData.width; eightPx += 8) {
							let byte = 0
							for (let px = 0; px < 8; px++) {
								const offset = (l * imageData.width + eightPx + px) * 4
								const bitMask = 128 >> px
								const r = data[offset]
								const g = data[offset + 1]
								const b = data[offset + 2]
								const a = data[offset + 3]
								const black = (768 - (r + g + b)) * a > 60000 // max value is 196.608
								if (black) {
									byte = byte | bitMask
								}
							}
							imageByteLine.push(byte)
						}
					}
					// Debug output of bitmap
					/* imageByteLines.forEach(line => {
						let lineBuff = ''
						line.forEach(byte => {
							lineBuff += this._byteToBin(byte)
						})
						console.log(lineBuff)
					}) */
					// Crop image buffer
					this._crop(imageByteLines)
					// Init printer
					const b64 = new Base64Writer()
					this._initGsV0(imageByteLines[0].length, imageByteLines.length, b64)
					//this._initGs_L(imageByteLines[0].length, imageByteLines.length, b64)
					// Write bitmap to b64 buffer
					imageByteLines.forEach(imageByteLine => imageByteLine.forEach(byte => b64.writeByte(byte)))
					// Flush
					this._printAndFlush(b64)
					// this._printAndFlushGS_L(imageByteLines[0].length, imageByteLines.length, b64)
					// this._printAndFlushGS_L(imageData.width, imageData.height, b64)
					// console.debug(b64.getBase64())
					resolve(`rawbt:base64,${b64.getBase64()}`)
				})
		})
	}

	/**
	 * Remove leading and trailing empty lines
	 * 
	 * @param {*} imageByteLines 
	 */
	_crop = imageByteLines => {
		const isLineEmpty = imageByteLine => !imageByteLine.some(byte => byte !== 0)
		let lineIsEmpty = isLineEmpty(imageByteLines[0])
		while (lineIsEmpty) {
			imageByteLines.shift()
			lineIsEmpty = isLineEmpty(imageByteLines[0])
		}
		lineIsEmpty = isLineEmpty(imageByteLines[imageByteLines.length - 1])
		while (lineIsEmpty) {
			imageByteLines.pop()
			lineIsEmpty = isLineEmpty(imageByteLines[imageByteLines.length - 1])
		}
		//imageByteLines.forEach(imageByteLine => console.debug(imageByteLine.map(byte => this._byteToBin(byte)).join('')))
	}

	_byteToBin = byte => `${(byte & 128) ? '#' : '.'}${(byte & 64) ? '#' : '.'}${(byte & 32) ? '#' : '.'}${(byte & 16) ? '#' : '.'}${(byte & 8) ? '#' : '.'}${(byte & 4) ? '#' : '.'}${(byte & 2) ? '#' : '.'}${(byte & 1) ? '#' : '.'}`

	/**
	 * See: https://reference.epson-biz.com/modules/ref_escpos/index.php?content_id=94
	 * 
	 * @param {*} width in bytes á 8 bit
	 * @param {*} height 
	 * @param {*} b64 
	 */
	_initGsV0 = (width, height, b64) => {
		// Initialize printer
		b64.writeByte(27) // ESC 1b init
		b64.writeByte(64) // @ 40 ...

		// GS v 0
		// 1b  40 1d 76 30 00 10   00 94 00 00 00 00 00 00 00
		// ESC @  GS L  0  0  DLE  0  94 0  0  0  0  0  0  0 init, left margin (0,0), Transmit real-time status
		b64.writeByte(29) // GS 1d left margin (0,0)
		b64.writeByte(118) // "v" 76
		b64.writeByte(48) // "0" 30
		b64.writeByte(0) // m Mode single density
		b64.writeByte(this._getLByte(width)) // xL width[px] -> width[byte] -> lowByte
		b64.writeByte(this._getHByte(width)) // xH width[px] -> width[byte] -> highByte
		b64.writeByte(this._getLByte(height)) // yL height[px] -> lowByte
		b64.writeByte(this._getHByte(height)) // yH height[px] -> highByte
	}

	/**
	 * See: https://reference.epson-biz.com/modules/ref_escpos/index.php?content_id=99#gs_lparen_cl_fn112
	 * 
	 * @param {*} width in bytes á 8 bit
	 * @param {*} height 
	 * @param {*} b64 
	 */
	_initGs_L = (width, height, b64) => {
		// Initialize printer
		b64.writeByte(27) // ESC 1b init
		b64.writeByte(64) // @ 40 ...
		// Store image data GS ( L
		// 29 40 76 pL pH 48 112 a bx by c xL xH yL yH d1...dk
		b64.writeByte(29)
		b64.writeByte(40)
		b64.writeByte(76)
		b64.writeByte(this._getLByte(width * height))
		b64.writeByte(this._getHByte(width * height))
		b64.writeByte(48)
		b64.writeByte(112)
		b64.writeByte(48)
		b64.writeByte(1) // "G" 71
		b64.writeByte(1) // "1" 49
		b64.writeByte(49)
		b64.writeByte(this._getLByte(width)) // xL width[px] -> width[byte] -> lowByte
		b64.writeByte(this._getHByte(width)) // xH width[px] -> width[byte] -> highByte
		b64.writeByte(this._getLByte(height)) // yL height[px] -> lowByte
		b64.writeByte(this._getHByte(height)) // yH height[px] -> highByte
	}

	/**
	 * See: https://www.epson-biz.com/modules/ref_escpos/index.php?content_id=15
	 * 
	 * @param {*} b64 
	 */
	_printAndFlush = b64 => {
		b64.writeByte(27) // ESC 1b init
		b64.writeByte(74) //J 4A
		b64.writeByte(0) // 0 motion unit feed
		// Initialize printer
		b64.writeByte(27) // ESC 1b init
		b64.writeByte(64) // @ 40 ...
	}

	/**
	 * See: https://www.epson-biz.com/modules/ref_escpos/index.php?content_id=98#gs_lparen_cl_fn50
	 * 
	 * @param {*} width in bytes á 8 bit
	 * @param {*} height 
	 * @param {*} b64 
	 */
	_printAndFlushGS_L = (width, height, b64) => {
		b64.writeByte(29) // Decimal: 29 40 76 2 0 48 fn
		b64.writeByte(40)
		b64.writeByte(76)
		b64.writeByte(2)
		b64.writeByte(0)
		b64.writeByte(48)
		b64.writeByte(50)
		// Initialize printer
		b64.writeByte(27) // ESC 1b init
		b64.writeByte(64) // @ 40 ...
	}

	/**
	 * Not working
	 * @param {*} url 
	 */
	_sendUrl = url => {
		fetch(url, {
			method: 'GET',
		})
			.then(response => {
				if (response.status === 200) {
					alert('Print data sent.')
				}
				else {
					alert('Unexpected response code: ' + response.status)
				}
			})
			.catch(e => {
				alert('Failed to send data: ' + e)
			})
	}

	/**
	 * Not working
	 * @param {*} base64 
	 */
	_sendToWebsocket = base64 => {
		var socket = new WebSocket("ws://127.0.0.1:40213/")
		socket.bufferType = "arraybuffer"
		socket.onerror = error => {
			alert(JSON.stringify(error))
		}
		socket.onopen = () => {
			socket.send('intent:base64,' + base64)
			socket.close(1000, "Work complete")
		}
	}

	_getLByte = val => val & 255

	_getHByte = val => (val >> 8) & 255

}